import React, { createContext, useState } from "react";

const QueueViewContext = createContext([]);

const QueueViewProvider = ({ children }) => {
  const [currentQueueView, setCurrentQueueView] = useState([]);

  return (
    <QueueViewContext.Provider
      value={{ currentQueueView, setCurrentQueueView }}
    >
      {children}
    </QueueViewContext.Provider>
  );
};

export { QueueViewProvider, QueueViewContext };
